"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var buttons_1 = require("../../buttons");
var InputEstimate_1 = require("./InputEstimate");
var TripleEstimatesForm = function (props) { return (React.createElement("table", { className: "TripleEstimatesForm" },
    React.createElement("tr", null,
        React.createElement("td", null),
        React.createElement("td", null, pgettext("Header for Frequency and Consequence", "Low")),
        React.createElement("td", null, pgettext("Header for Frequency and Consequence", "Medium")),
        React.createElement("td", null, pgettext("Header for Frequency and Consequence", "High"))),
    React.createElement("tr", null,
        React.createElement("th", null, gettext("Frequency")),
        props.estimates.filter(function (value) { return value.type == 'freq'; }).map(function (value) { return (React.createElement("td", null,
            React.createElement(InputEstimate_1.default, { name: value.name, value: value.value, invalid: !value.valid || props.invalidFrequencies, change: props.change }))); }),
        React.createElement("td", null, "\u00A0"),
        React.createElement("td", null, "\u00A0"),
        React.createElement("td", null, "\u00A0"),
        React.createElement("td", { className: "TripleEstimatesForm__Mean" },
            gettext("Frequency mean-value"),
            ":"),
        React.createElement("td", { className: "TripleEstimatesForm__Value" }, props.fmean)),
    React.createElement("tr", null,
        React.createElement("th", null, gettext("Consequence")),
        props.estimates.filter(function (value) { return value.type == 'cons'; }).map(function (value) { return (React.createElement("td", null,
            React.createElement(InputEstimate_1.default, { name: value.name, value: value.value, invalid: !value.valid || props.invalidConsequences, change: props.change }))); }),
        React.createElement("td", null, props.unit),
        React.createElement("td", null, "\u00A0"),
        React.createElement("td", null, "\u00A0"),
        React.createElement("td", { className: "TripleEstimatesForm__Mean" },
            gettext("Consequence mean-value"),
            ":"),
        React.createElement("td", { className: "TripleEstimatesForm__Value" }, props.cmean)),
    React.createElement("tr", null,
        React.createElement("td", { colSpan: 4 },
            React.createElement(buttons_1.ActionButton, { disabled: props.invalid, className: "TripleEstimatesForm__Button", onClick: props.click }, gettext("Evaluate"))),
        React.createElement("td", null, "\u00A0"),
        React.createElement("td", null, "\u00A0"),
        React.createElement("td", null, "\u00A0"),
        React.createElement("td", { className: "TripleEstimatesForm__Mean" },
            gettext("Risk Value"),
            ":"),
        React.createElement("td", { className: "TripleEstimatesForm__Value" }, props.var)))); };
exports.default = TripleEstimatesForm;
